import React, { useState, useEffect } from 'react'

import {Grid} from '@mui/material'

import ComponentContainer from '../../core/template/ComponentContainer';
import {CoreContext} from "../../core/context/CoreContext";
import PackagingsizeEditFormImpl from './PackagingsizeEditFormImpl';
import PackagingsizeList from './PackagingsizeList';
import { useSelector, useDispatch } from 'react-redux';

import Notification from '../../core/components/Notification';

import PackagingsizeListView from './PackagingsizeListView'


export default function PackagingsizeDashboard(){
  const { setKeyValue, getKeyValues, keyvalues } = React.useContext(CoreContext);
  const {showEdit} = useSelector((state)=>state.pharmaslice.packagingsizeDashboard);
  const [ packagingsizeId, setPackagingsizeId] = React.useState('');
  const [reloadPackagingsizeList, setReloadPackagingsizeList] = useState(true);

  return (
      <>
      <Notification/>
      {showEdit?
        <ComponentContainer containedComponent = {
          <PackagingsizeEditFormImpl 
            setReloadPackagingsizeList={setReloadPackagingsizeList}
            packagingsizeId={packagingsizeId}
            />}/>:
            <>
            <Grid container direction="column" >
              <Grid item>
                    {
                      <PackagingsizeListView 
                      setPackagingsizeId = {setPackagingsizeId}/>
                    }
              </Grid>
            </Grid>
            </>
      }
    </>


  )

}
